import React, { Component } from "react";
import "../style/document.scss";
import HeadBar from "./common/HeadBar";
import card from "../image/card2.gif";
import { routePage } from "../utils/routePage";
import safeParse from "../utils/SafeParseLocalstrorage";
import { lang } from "../utils/lang";
import getAd from "../utils/GetAd";

class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ad: getAd(),
    };
  }

  render() {
    let { history, location } = this.props;
    let { ad } = this.state;
    return (
      <React.Fragment>
        <div className="document-page">
          <HeadBar {...this.props} />
          <div className="document-box">
            <h1>Identity Verification</h1>
            <h2>
              Please ensure that all text and the barcode on the document are
              clearly visible, and that all edges of the document are fully
              visible and not obscured.
            </h2>
            <div className="gif-box">
              <img src={card} alt="" />
            </div>
            <div
              className="btn"
              onClick={() => routePage(history, ad, "/Info")}
            >
              {lang.next}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Document;
